import { preferTrainTrips } from "../../../Lib/Utils/booking";
import { shuttleServesDirection } from "../../../Lib/Utils/tripDirectionRecovery";
import { TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";

/**
 * Split a round-trip list row's `tripIds` into the train it leads with outbound
 * and the train it returns on, by the leg each trip serves on the booking.
 *
 * Position is what the next-ticket split used, and it is only right while the
 * row holds exactly `[outbound, inbound]`. A fold orders `tripIds` primary-
 * first and can carry a feeder shuttle, so `[0]` / `[1..]` could hand outbound
 * trips to the return leg. Directions go through shuttleServesDirection, which
 * reads a shuttle off the train it connects to (the backend stamps every
 * shuttle OUT_BOUND).
 *
 * TRAINS only, as `[0]` always was: the change-date gate (BookingData) hides
 * its item only when EVERY id is blocked, so a feeder shuttle's id here could
 * bring the item back for a train the backend refuses. Shuttles reach the card
 * through withShuttleFlag instead.
 *
 * Null when either half finds no train — the caller keeps the positional split.
 */
export const splitRowTripsByLeg = (
    rowTripIds: string[] | undefined,
    bookingTrips: any[] | undefined
): { outbound: string[]; inbound: string[] } | null => {
    const trips = bookingTrips || [];
    const serving = (direction: TripTypeEnum.OUT_BOUND | TripTypeEnum.IN_BOUND): string[] => {
        const legTrains = preferTrainTrips<any>(
            trips.filter((trip: any) => shuttleServesDirection(trip, trips, direction))
        );
        return (rowTripIds || []).filter((id) => legTrains.some((trip: any) => trip.id === id));
    };
    const outbound = serving(TripTypeEnum.OUT_BOUND);
    const inbound = serving(TripTypeEnum.IN_BOUND);
    return outbound.length > 0 && inbound.length > 0 ? { outbound, inbound } : null;
};
